import { render, staticRenderFns } from "./UpdateNewsItemPage.vue?vue&type=template&id=6ad019d0&scoped=true&"
import script from "./UpdateNewsItemPage.vue?vue&type=script&lang=js&"
export * from "./UpdateNewsItemPage.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNewsItemPage.vue?vue&type=style&index=0&id=6ad019d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad019d0",
  null
  
)

export default component.exports